import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { InputOption } from '../../../filters/filter-types/types';

@Component({
  selector: 'app-button-radio',
  styleUrls: ['./button-radio.component.scss'],
  imports: [ReactiveFormsModule],
  template: `<button (click)="onClick(value)">
    <div class="label-md">
      <div class="ellipses-label">{{ label }}</div>
    </div>
    <div class="radio-wrapper">
      <input
        type="radio"
        value="{{ value }}"
        [checked]="selected === value"
        class="radio"
        [attr.is-checked]="selected === value"
      />
    </div>
  </button>`,
  standalone: true,
})
export class ButtonRadioComponent {
  @Input()
  id: string;

  @Input()
  label: string;

  @Input()
  value: any;

  @Input()
  selected: any;

  @Input()
  onClick: (value: any) => unknown;
}
